import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Step} from "../types.ts";
import {useStep} from "../hooks/useStep.ts";
import {useParams} from "react-router-dom";


export const AddFormDrawer = (props: DrawerProps) => {

    const {id: playbookId, phaseId} = useParams();

    const {
        record,
        createRecord,
    } = useStep();

    // Seed phaseId and playbookId from the parent route so the mutation input
    // satisfies the non-null StepsFilterInput/CreateStepInput constraints.
    // Same pattern as organization-accounts/drawers/AddFormDrawer.tsx (FNP-46).
    const seededRecord = {
        ...(record ?? {}),
        ...(playbookId ? {playbookId} : {}),
        ...(phaseId ? {phaseId} : {}),
    } as Step;

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
